import { useEffect, useState } from "react";
import QRScan from "../../components/qr_scan";
import { Controller, useForm } from "react-hook-form";
import CONFIG from "../../constanta/config";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import useUser from "../../hook/useUser";
import ReactSelect from "react-select";
import moment from "moment";

const FormThankyou = (props) => {
  return (
    <>
      <div className="space-y-5 px-5 py-10 bg-white rounded-md w-full md:w-1/2 transition-all">
        <div className="text-center font-bold mb-8">
          <div className="text-2xl mt-5">
            Hi, {props.user?.first_name}{" "}
            {props.user?.last_name !== "" ? " " + props.user?.last_name : ""}
          </div>
          <div className="text-base font-normal">
            Birth Date :{" "}
            {moment(props.user?.birth_date).format("MMMM, DD YYYY")}
          </div>
          <div className="text-base font-normal">
            Department : {props.user?.departement}
          </div>
        </div>

        <div className="flex flex-col">
          <div className="text-center text-xl font-bold">
            Thank you for submitting your registration!
          </div>
        </div>
        <div className="flex flex-col w-full justify-center items-center text-center">
          <div className="text-base font-normal text-center">
            For staff, an email containing the event details and your QR code
            has been sent.
          </div>
          <div className="text-base font-normal text-center">
            For guests, an email containing their QR code would be sent within
            48 hours.
          </div>
          <div className="text-base font-normal text-center mt-3">
            Please check your spam/junk email folders
          </div>
          <div className="text-base font-normal text-center">
            if you do not see the email in your primary inbox.
          </div>
          <div className="text-base font-normal text-center mt-5">
            We look forward to hosting you!
          </div>
        </div>

        {/* <div className="mx-auto flex justify-center items-center">
          <button
            type="button"
            onClick={() => props.ok()}
            className={`mt-10 w-[340px]  px-10 py-2 rounded-lg text-white font-bold bg-green-500  w-full text-center`}
          >
            OK
          </button>
        </div> */}
      </div>
    </>
  );
};

export default FormThankyou;
